export default "__VITE_ASSET__DrTPvUFo__"